module.exports = {"520626001":"青龙街道","520626002":"玉水街道","520626101":"煎茶镇","520626102":"潮砥镇","520626103":"枫香溪镇","520626104":"稳坪镇","520626105":"复兴镇","520626106":"合兴镇","520626107":"高山镇","520626108":"泉口镇","520626109":"长堡镇","520626110":"共和镇","520626111":"平原镇","520626200":"荆角土家族乡","520626201":"堰塘土家族乡","520626202":"龙泉土家族乡","520626203":"钱家土家族乡","520626204":"沙溪土家族乡","520626205":"楠杆土家族乡","520626206":"长丰土家族乡","520626207":"桶井土家族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520626.json
// module id = 2498
// module chunks = 0